export function plural(count: any, options: any) {
	if (options.length !== 3) return '';

	count = Math.abs(count) % 100;

	const rest = count % 10;

	if (count > 10 && count < 20) return options[2];

	if (rest > 1 && rest < 5) return options[1];

	if (rest === 1) return options[0];

	return options[2];
}

/**
 * Число прописью
 * @param value Число
 * @param integral массив строк 
 * @param fractional 
 * @returns 
 */
export default function numberToString(value: any, integral: any = null, fractional: any = null) {
	const words = [
		[
			'', 'один', 'два', 'три', 'четыре', 'пять', 'шесть', 'семь', 'восемь', 'девять',
			'десять', 'одиннадцать', 'двенадцать', 'тринадцать', 'четырнадцать',
			'пятнадцать', 'шестнадцать', 'семнадцать', 'восемнадцать', 'девятнадцать'
		],
		[
			'', '', 'двадцать', 'тридцать', 'сорок', 'пятьдесят', 'шестьдесят', 'семьдесят', 'восемьдесят', 'девяносто'
		],
		[
			'', 'сто', 'двести', 'триста', 'четыреста', 'пятьсот', 'шестьсот', 'семьсот', 'восемьсот', 'девятьсот'
		]
	];

	function parseNumber(number: any, count: any) {
		let first: any;
		let second: any;
		let numeral = '';

		if (number.length === 3) {
			first = number.substr(0, 1);
			number = number.substr(1, 3);
			numeral = '' + words[2][first] + ' ';
		}

		if (number < 20) {
			numeral = numeral + words[0][parseFloat(number)] + ' ';
		} else {
			first = number.substr(0, 1);
			second = number.substr(1, 2);
			numeral = numeral + words[1][first] + ' ' + words[0][second] + ' ';
		}

		if (count === 0) {
			if (integral) numeral = numeral + plural(number, integral);

		} else if (count === 1) {
			if (numeral !== '  ') {
				numeral = numeral + plural(number, ['тысяча ', 'тысячи ', 'тысяч ']);
				numeral = numeral.replace('один ', 'одна ').replace('два ', 'две ');
			}

		} else if (count === 2) {
			if (numeral !== '  ') {
				numeral = numeral + plural(number, ['миллион ', 'миллиона ', 'миллионов ']);
			}

		} else if (count === 3) {
			if (numeral !== '  ') {
				numeral = numeral + plural(number, ['миллиард ', 'миллиарда ', 'миллиардов ']);
			}

		} else if (count === 4) {
			numeral = numeral + plural(number, ['триллион ', 'триллиона ', 'триллионов ']);
		}

		return numeral;
	}

	function parseDecimals(number: any) {
		let result = number;

		if (result === 0) {
			result = '00';
		} else if (result < 10) {
			result = '0' + result;
		}

		return fractional ? ' ' + result + ' ' + plural(number, fractional) : result;
	}

	function sumaInCuirsive(number: any) {
		if (!number) return false;

		const type = typeof number;

		if (type !== 'number' && type !== 'string') return false;

		if (type === 'string') {
			number = parseFloat(number.replace(',', '.'));

			if (isNaN(number)) return false;
		}

		if (number <= 0) return false;

		let splt: any;
		let decimals: any;

		number = number.toFixed(2);

		if (number.indexOf('.') !== -1) {
			splt = number.split('.');

			number = splt[0];
			decimals = fractional || splt[1] != '00' ? splt[1] : null;
		}

		let numeral = '';
		let length = number.length - 1;
		let parts = '';
		let count = 0;
		let digit: any;

		while (length >= 0) {
			digit = number.substr(length, 1);
			parts = digit + parts;

			if ((parts.length === 3 || length === 0) && !isNaN(parseFloat(parts))) {
				numeral = parseNumber(parts, count) + numeral;

				parts = '';
				count++;
			}

			length--;
		}

		numeral = numeral.replace(/\s+/g, ' ');

		if (decimals) {
			numeral = numeral + parseDecimals(parseFloat(decimals));
		}

		return numeral;
	}

	return sumaInCuirsive(value);
}
